var _excluded = ["setButtonRef", "isLoading", "media"];
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import { Loader } from '@domain-group/fe-blueprint-ui/loader';
import { useSendEvent } from '@domain-group/fe-co-allhomes-analytics';
import WatchlistIcon from './watchlist-icon';
import styleFactory from './watchlist-button.style';
import { jsx as ___EmotionJSX } from "@emotion/core";
var WatchlistButton = _ref => {
  var setButtonRef = _ref.setButtonRef,
    isLoading = _ref.isLoading,
    media = _ref.media,
    props = _objectWithoutProperties(_ref, _excluded);
  var _useSendEvent = useSendEvent(),
    sendEvent = _useSendEvent.sendEvent;
  var styles = styleFactory(props);
  var desktop = media.desktop;
  var hasButtonText = desktop && !props.noText;
  var ref = useCallback(node => {
    if (node !== null) {
      setButtonRef(node);
    }
  }, [setButtonRef]);
  var buttonStyle = [styles.button, props.isInWatchlist && styles.inWatchlist];
  var handleOnClick = event => {
    if (!isLoading) {
      if (!props.isInWatchlist) {
        sendEvent('add-to-watchlist-click');
      }
      props.onClick(event);
    }
  };
  return ___EmotionJSX("button", {
    type: "button",
    onClick: handleOnClick,
    css: buttonStyle
  }, hasButtonText && ___EmotionJSX("span", {
    "data-testid": "button-text",
    css: styles.text
  }, "".concat(props.isInWatchlist ? 'Added' : 'Add', " to watchlist")), ___EmotionJSX("span", {
    ref: ref
  }, isLoading ? ___EmotionJSX(Loader, {
    css: styles.spinner,
    size: "mini",
    noIcon: true
  }) : ___EmotionJSX(WatchlistIcon, {
    active: props.isInWatchlist,
    inactiveColour: props.inactiveColour,
    activeColour: props.activeColour
  })));
};
WatchlistButton.propTypes = {
  isInWatchlist: PropTypes.bool,
  isLoading: PropTypes.bool,
  onClick: PropTypes.func,
  media: PropTypes.objectOf(PropTypes.bool),
  noText: PropTypes.bool,
  inactiveColour: PropTypes.string,
  activeColour: PropTypes.string,
  setButtonRef: PropTypes.func
};
WatchlistButton.defaultProps = {
  isInWatchlist: false,
  isLoading: false,
  noText: false,
  onClick: () => {},
  media: {},
  inactiveColour: undefined,
  activeColour: undefined,
  setButtonRef: () => {}
};
export default WatchlistButton;